import React, { useState } from 'react';

import Draggable from 'react-draggable';
import Paper, { PaperProps } from '@mui/material/Paper';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import styled from 'styled-components';

import DateHelper from '../../Utilities/Helpers/DateHelper';

import { InstanceAutoBackupsListField } from '../../Utilities/Enums/ParametersEnum';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';

import CustomButton from '../../CustomViews/Elements/CustomButton';

import { BackupRestoreConfirmationDialogModel } from '../../Models/InstanceManagement/InstanceManagement';

const CustomDialogContent = styled(DialogContent) <{ }>`
    width: '20vw';
    font-size: 14px;
    
    .instanceName {
        font-weight: 600;
    }
`;

function DraggablePaperComponent(props: PaperProps) {
    const nodeRef = React.useRef<HTMLDivElement>(null);

    return (
        <Draggable
            nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
            handle="#alert-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'} >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const BackupRestoreConfirmationModal = (fieldProps: BackupRestoreConfirmationDialogModel) => {
    fieldProps = { ...new BackupRestoreConfirmationDialogModel(), ...fieldProps };
    let backupDate: string | Date | null = fieldProps?.selectedRecord?.[InstanceAutoBackupsListField.BACKUP_DATE] != null && fieldProps?.selectedRecord?.[InstanceAutoBackupsListField.BACKUP_DATE] != "" ? DateHelper.getFormattedDate(fieldProps?.selectedRecord?.[InstanceAutoBackupsListField.BACKUP_DATE], "dd/MM/yyyy hh:mm a") : null;

    //Use States
    //Variables

    return <Dialog {...{
        PaperComponent: DraggablePaperComponent,
        open: fieldProps?.openDialog ?? false,
        onClose: () => {
            if(fieldProps?.handleClose) {
                fieldProps.handleClose();
            }
        },
        'aria-labelledby': "customized-dialog-title",
        'aria-describedby': "alert-dialog-description",
        TransitionProps: {
            onExited: () => {
                if(fieldProps?.handleClose) {
                    fieldProps.handleClose();
                }
            }
        },
    }} >
        <DialogTitle style={{ cursor: 'move' }} id="alert-dialog-title">Confirm</DialogTitle>

        <CustomDialogContent>
            <DialogContentText id="alert-dialog-description">
                Restore <span className='instanceName'>{fieldProps?.instanceName}</span> from backup taken <span className='instanceName'>{backupDate}</span>? 
                This overwrites current production data. 
                {/* The instance will enter maintenance mode during restore. */}
            </DialogContentText>
        </CustomDialogContent>

        <DialogActions>
            <CustomButton
                btnType={ButtonType.CANCEL_LIGHT}
                title='Close'
                onClick={(e: any) => {
                    e.preventDefault();
                    if(fieldProps?.handleClose) {
                        fieldProps.handleClose();
                    }
                }} />

            <CustomButton
                btnType={ButtonType.PRIMARY_NO_BG}
                title='Confirm'
                onClick={(e: any) => {
                    if(fieldProps?.buttonAction) {
                        fieldProps.buttonAction();
                    }
                }} />
        </DialogActions>
    </Dialog >
}

export default BackupRestoreConfirmationModal;
